export var PERSON_TYPE = [
    {
        label: "personType.natural",
        value: "0",
    },
    {
        label: "personType.legal",
        value: "1",
    },
];
